// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { CmsImageSizesFragmentDoc } from '../cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../imageSize.fragment.generated';
import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../index.generated';
export const LogoWithTextFragmentDoc = `
    fragment LogoWithText on LogoWithText {
  __typename
  title
  description
  image {
    ...cmsImageSizes
  }
  logoLink: link {
    ...link
  }
}
    `;
export const ComponentLogosWithTextFragmentDoc = `
    fragment ComponentLogosWithText on ComponentLogosWithText {
  __typename
  logos {
    ...LogoWithText
  }
}
    `;